import { Component, OnInit } from '@angular/core';
import { App1Service } from 'apps/app1/src/services/app1.service';
import { Subscription } from 'rxjs';
import { LoggerService } from 'libs/shared-lib1/src/lib/shared/services/logger.service';
import { LogLevel } from '@angular/compiler-cli';
import { LoggingLevel } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';
import { BaseUrlChangeDialogComponent } from 'libs/shared-lib1/src/lib/base-url-change-dialog/base-url-change-dialog.component';
import { DialogService } from 'libs/shared-lib1/src/lib/shared/services/decativateDialog/dialog.service';

@Component({
  selector: 'nxt-app1-error-handle',
  templateUrl: './app1-error-handle.component.html',
  styleUrls: ['./app1-error-handle.component.scss'],
})
export class App1ErrorHandleComponent extends BaseUrlChangeDialogComponent implements OnInit {

  dataWeWanted: any;

  constructor(
    private app1Service: App1Service,
    private loggerService: LoggerService,
    public override dialogService: DialogService

  ) {
    super(dialogService);
  }

  ngOnInit(): void {

    //demo error HANDLING
    let subscription: Subscription = this.app1Service.makeAnApiCall().subscribe(

      (data) => {


        this.dataWeWanted = data

      },

      (err) => {

        //Error handle and logging
        //https://medium.com/@dneimke/configurable-logging-in-angular-projects-30dd5d999db6
        console.log(err)


        //Here we can decide if we want to log as Error or warning etc'
        this.loggerService.log(err.message, LoggingLevel.Warnings)

      }
    );

  }
}
